// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-skill-band-title {
  width: 70%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 15px;
}

.text {
  font-size: 16px;
  text-transform: uppercase;
}

.text-container {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.text.title {
  font-weight: bold;
}

.number {
  width: 33%;
  text-align: center;
}

.numbers-container {
  margin: 7px 0 15px;
  display: flex;
}

.number {
  width: 100%;
  padding-left: 15px;
}

.value {
  width: 100%;
  text-align: left;
  font-size: 20px;
}

/* Media query for mobile */
@media (max-width: 768px) {
  .label {
    font-size: 8px;
    text-transform: uppercase;
  }
  .value {
    font-size: 16px;
  }
}
.container-skill-band-triple {
  padding-top: 10px;
  margin-top: 20px;
  padding-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/widget-counter-band-triple/widget-counter-band-triple.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA,2BAAA;AACA;EACE;IACE,cAAA;IACA,yBAAA;EACF;EAEA;IACE,eAAA;EAAF;AACF;AAGA;EAGE,iBAAA;EACA,gBAAA;EACA,oBAAA;AAHF","sourcesContent":[".container-skill-band-title {\n  width: 70%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-left: 15px;\n}\n\n.text {\n  font-size: 16px;\n  text-transform: uppercase;\n}\n\n.text-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n}\n\n.text.title {\n  font-weight: bold;\n}\n\n.number {\n  width: 33%;\n  text-align: center;\n}\n\n.numbers-container {\n  margin: 7px 0 15px;\n  display: flex;\n}\n\n.number {\n  width: 100%;\n  padding-left: 15px;\n}\n\n.value {\n  width: 100%;\n  text-align: left;\n  font-size: 20px;\n}\n\n/* Media query for mobile */\n@media (max-width: 768px) {\n  .label {\n    font-size: 8px;\n    text-transform: uppercase;\n  }\n\n  .value {\n    font-size: 16px;\n  }\n}\n\n.container-skill-band-triple {\n  //background-color: #65b8ca;\n  //background-color: rgb(255, 255, 255, 0.3);\n  padding-top: 10px;\n  margin-top: 20px;\n  padding-bottom: 10px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
